export default "__VITE_ASSET__BMkzIz1L__"